import { BeaconsService } from '@karnott/core-js';
import { API_BASE } from '../../constants';

export default new BeaconsService({
  apiBase: API_BASE,
});
